// CKEditor "Apply Template" templates are served by configAPI through the
// metadataConfiguration query (see metadataConfigurationProvider.js) and filtered
// on the client by the relevant Content Area.

const filterTemplatesByTypeAndContentArea =
  (type) =>
  (templates = []) =>
  (contentArea) =>
    templates.filter(
      (template) =>
        template?.type === type &&
        (template?.contentAreas ?? []).includes(contentArea),
    );

export const filterItemTemplatesByContentArea =
  filterTemplatesByTypeAndContentArea("item");

export const filterPassageTemplatesByContentArea =
  filterTemplatesByTypeAndContentArea("passage");

export const filterFoilTemplatesByContentArea =
  filterTemplatesByTypeAndContentArea("foil");
